import { atom } from 'jotai';

export const isShortcutsSheetOpenAtom = atom(false);

export const isShortcutsDisabledAtom = atom(false);
